import React from "react";
import styled from "styled-components";
export const Addon = ({
  title,
  children,
  image,
  button,
  ...props
}) => {
  return React.createElement(AddonWrap, props, React.createElement(LeftContainer, null, React.createElement(Image, null, image), button), children && React.createElement(ContentContainer, null, children));
};
const AddonWrap = styled.div`
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.cardAddonBorder};
  box-sizing: border-box;
  display: inline-flex;
  flex-flow: row nowrap;
  padding: 24px;
  position: relative;
  max-width: 496px;
`;
const LeftContainer = styled.div`
  align-items: center;
  min-width: 140px;
  display: inline-flex;
  flex-flow: column wrap;
  justify-content: center;
`;
const Image = styled.div`
  margin-bottom: 35px;
`;
const ContentContainer = styled.div`
  display: inline-flex;
  flex-flow: column wrap;
  padding-left: 40px;
  width: 100%;
`;